import type { Contact, Profile } from "../types";

export const profile: Profile = {
  name: {
    en: "Artyom Tarasov",
    ru: "Артём Тарасов",
  },
  role: {
    en: "Lead Mobile Developer",
    ru: "Ведущий мобильный разработчик",
  },
  // {years} is substituted with the auto-computed experience (see lib/experience).
  tagline: {
    en: "{years} years in mobile — I lead the engineering on Android products: technical direction, the quality bar and delivery across Kotlin, Coroutines, Compose and KMM, and go wide into iOS, Flutter and backend when a product needs it.",
    ru: "{years} лет в мобильной разработке — веду инженерную часть Android-продуктов: техническое направление, качество и доставку до релиза. Основной стек — Kotlin, Coroutines, Compose и KMM; когда нужно продукту, берусь за iOS, Flutter и бэкенд.",
  },
  // Started commercial Android development in March 2017.
  careerStart: "2017-03-01",
  commercialProjects: "50+",
  skills: {
    en: [
      "Java & Kotlin",
      "Native Android (Java, Kotlin)",
      "Jetpack Compose",
      "MVP, MVVM, MVI & Clean Architecture",
      "TDD — JUnit 4/5, Espresso",
      "Robolectric, Kaspresso, UI Automator",
      "CI/CD & code review",
      "Koin, Coil, Ktor, Coroutines",
      "Retrofit2, Gson, OkHttp3, Ion, iText",
      "REST APIs, WebSocket & JSON",
      "SQLite, SQL (JDBC)",
      "Firebase — Realtime DB & Cloud Firestore",
      "Google Cloud Messaging, Huawei Messaging Service",
      "Cross-platform — Flutter (KMM, Dart)",
      "iOS (Swift)",
      "Web (JS, PHP)",
      "Git",
    ],
    ru: [
      "Java и Kotlin",
      "Нативный Android (Java, Kotlin)",
      "Jetpack Compose",
      "MVP, MVVM, MVI и Clean Architecture",
      "TDD — JUnit 4/5, Espresso",
      "Robolectric, Kaspresso, UI Automator",
      "CI/CD и код-ревью",
      "Koin, Coil, Ktor, Coroutines",
      "Retrofit2, Gson, OkHttp3, Ion, iText",
      "REST API, WebSocket и JSON",
      "SQLite, SQL (JDBC)",
      "Firebase — Realtime DB и Cloud Firestore",
      "Google Cloud Messaging, Huawei Messaging Service",
      "Кросс-платформа — Flutter (KMM, Dart)",
      "iOS (Swift)",
      "Web (JS, PHP)",
      "Git",
    ],
  },
};

export const contacts: Contact[] = [
  {
    icon: "email",
    label: { en: "Email", ru: "Почта" },
    value: { en: "lorddarthart@yandex.ru", ru: "lorddarthart@yandex.ru" },
    href: "mailto:lorddarthart@yandex.ru",
  },
  {
    icon: "github",
    label: { en: "GitHub", ru: "GitHub" },
    value: { en: "@LordDarthArt", ru: "@LordDarthArt" },
    href: "https://github.com/LordDarthArt",
  },
  {
    // Value & href are resolved at runtime to match the current host
    // (lorddarthart.github.io vs lorddarthart.ru) — see Contacts.tsx.
    icon: "website",
    label: { en: "Website", ru: "Сайт" },
    value: { en: "lorddarthart.ru", ru: "lorddarthart.ru" },
    href: "https://lorddarthart.ru",
  },
  {
    icon: "location",
    label: { en: "Location", ru: "Адрес" },
    value: { en: "Saint-Petersburg, Russia", ru: "Санкт-Петербург, Россия" },
    href: "https://maps.app.goo.gl/i/fMm-M",
  },
];
